export const BaseUrl = process.env.REACT_APP_BASE_URL || "";
export const MainServerUrl =
  process.env.REACT_APP_BACKEND || "https://nitw.ac.in";
export const OldServerUrl = "https://oldweb.nitw.ac.in";
